import { useRouteMatch } from "react-router-dom";
import { linkToBroadcast } from "ui/navigation/links";

export default () => {
  const match = useRouteMatch(linkToBroadcast);

  return Boolean(match?.isExact);
};
